class HelpdeskTicket {
  id: number;
  name: string;
  isClosed: boolean;

  static fromJSON(o: Object): HelpdeskTicket {
    const ticket = new HelpdeskTicket();
    
    // Normalize ID
    ticket.id = typeof o["id"] === 'number' ? o["id"] : parseInt(o["id"]) || -1;
    
    // Map name field - API returns "name" or "display_name", normalize "False" strings
    const normalizeString = (value: any): string => {
      if (!value || value === false || value === 'False') return '';
      if (typeof value === 'string') return value.trim();
      return String(value);
    };
    
    ticket.name = normalizeString(o["name"]) || 
                  normalizeString(o["display_name"]) || 
                  normalizeString(o["issue_name"]) || 
                  `Ticket #${ticket.id}`;
    
    // Map closed status - ticket is closed if close_date exists and is truthy
    ticket.isClosed = !!(o["close_date"] && o["close_date"] !== false && o["close_date"] !== 'False');
    
    return ticket;
  }
}

export default HelpdeskTicket;
